import { RtbAPI } from "generated-api"
import { checkIfSessionIsOrWillExpired } from "user/tools/common"
import { ICurrency, ICurrencyRepository } from "./model"

export const currencyRPO: ICurrencyRepository = {
  getAllCurrencies(): Promise<ICurrency[]> {
    return new Promise<ICurrency[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        RtbAPI.getApiCurrencyList()
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while getting all rtb currencies", error)
            reject("currency.get.all.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting all rtb currencies", ex)
        reject("currency.get.all.error.unexpected")
      }
    })
  }
}
